module.exports = __webpack_public_path__ + "media/components/images/flows/5-5ed8d2eefe102f0f53cc60d7cb764649.svg";